import groq from 'groq';

import { PERSON, RICH_TEXT } from '../common';

export const PEOPLE_BLOCK = groq`
  _type,
  title,
  description[] {
    ${RICH_TEXT}
  },
  people[]->{
    ${PERSON},
  }
`;
